
// import User from '../../../../server/schema/schema.js';

import axios from 'axios';
// const URL = "http://localhost:9100/";

const URL = "https://blog-backend-p711.onrender.com/";


export const submit_data=async(data)=>{
    try{
        return await axios.post(`${URL}senddata`,data);
    }
    catch(err)
    {
        return { "error ": err.message + " : submitdata" };
    }
}
export const update_data=async(data)=>{
  console.log(data[1]);
  var id = data[1];
  try{
    return await axios.post(`${URL}updatedata/:${id}`,data);
  }
  catch(err)
  {
    return { "error ": err.message + " : updatedata" };
  }
}
export const getobj_byid=async(id)=>{
  try{
    return await axios.get(`${URL}edit/:${id}`);
    // edit/:id
  }
  catch(err){
    return { "error ": err.message + " : getobj_byid" };
  }
}

export const getdata = async (req,resp) => {
  try {
    return await axios.get(`${URL}getdata`);
  } catch (err) {
    resp.status(400).json({ message: err.message + " : getdata" });
  }
};



export const getdata_tech=async (req,resp)=>{
  try{
    return await axios.get(`${URL}gettechdata`);
  }
  catch(err)
  { 
    resp.status(501).json({ message: err.message + " : gettechdata" });
  }
}



export const calldailyposy=async(req,res)=>{
  try{
      return await axios.get(`${URL}dailypost`);
  }
  catch(err)
  {
    res.status(501).json({ message: err.message+" : calldailypostapi" });
  }
}